/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Signal_EquityInputs */

const en_negotiation_signal_equity = /** @type {(inputs: Negotiation_Signal_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equity`)
};

const de_negotiation_signal_equity = /** @type {(inputs: Negotiation_Signal_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equity`)
};

const fr_negotiation_signal_equity = /** @type {(inputs: Negotiation_Signal_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equity`)
};

const es_negotiation_signal_equity = /** @type {(inputs: Negotiation_Signal_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equity`)
};

const it_negotiation_signal_equity = /** @type {(inputs: Negotiation_Signal_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equity`)
};

const nl_negotiation_signal_equity = /** @type {(inputs: Negotiation_Signal_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equity`)
};

const pl_negotiation_signal_equity = /** @type {(inputs: Negotiation_Signal_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equity`)
};

const fi_negotiation_signal_equity = /** @type {(inputs: Negotiation_Signal_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equity`)
};

const da_negotiation_signal_equity = /** @type {(inputs: Negotiation_Signal_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equity`)
};

const sv_negotiation_signal_equity = /** @type {(inputs: Negotiation_Signal_EquityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equity`)
};

/**
* | output |
* | --- |
* | "Equity" |
*
* @param {Negotiation_Signal_EquityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_signal_equity = /** @type {((inputs?: Negotiation_Signal_EquityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Signal_EquityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_signal_equity(inputs)
	if (locale === "fr") return fr_negotiation_signal_equity(inputs)
	if (locale === "es") return es_negotiation_signal_equity(inputs)
	if (locale === "it") return it_negotiation_signal_equity(inputs)
	if (locale === "nl") return nl_negotiation_signal_equity(inputs)
	if (locale === "pl") return pl_negotiation_signal_equity(inputs)
	if (locale === "fi") return fi_negotiation_signal_equity(inputs)
	if (locale === "da") return da_negotiation_signal_equity(inputs)
	if (locale === "sv") return sv_negotiation_signal_equity(inputs)
	return en_negotiation_signal_equity(inputs)
});